import { useStyles } from '@team-griffin/stylr';
import { useTheme, cssTheme, Colorway as Against } from '@uds/theme-utils';
import cssSides, { Side } from '@team-griffin/css-sides';
import { Alignment } from 'domain/constants/alignment';
import { getTitleColor, getBodyColor } from 'presentation/utils/colorway';
import { modifier } from '@ux/style-utils';
import { Layout } from 'domain/constants/layout';
import { useBreakpoints } from '@ux/responsive';
import findResponsiveItem from 'presentation/utils/findResponsiveItem';

import { ShortcodeAttributesProps } from './Shortcode';

export const useListStyles = ({
  layout,
  against,
  attributes,
}: {
  layout: Layout | undefined;
  against: Against | undefined;
  attributes: ShortcodeAttributesProps | undefined;
}) => {
  const { theme } = useTheme();

  const alignment = findResponsiveItem(useBreakpoints(), [
    layout?.alignmentMobile ?? Alignment.STARTING,
    layout?.alignmentTablet ?? Alignment.STARTING,
    layout?.alignment ?? Alignment.STARTING,
  ]);

  return useStyles(
    {
      default: {
        root: {
          listStylePosition: 'inside',
          ...cssSides('margin', Side.A, 0),
          marginBottom: cssTheme.gu2,
          paddingRight: 0,
          paddingLeft: 0,
          color: getBodyColor(theme, against),
        },

        icon: {
          color: getTitleColor(theme, against),
        },
      },
      glyph: {
        root: {
          listStyleType: 'none',
        },
      },
      [modifier('alignment', Alignment.CENTER)]: {
        root: {
          textAlign: 'center',
        },
      },
    },
    {
      against,
      alignment,
      glyph: (attributes?.style ?? null) === 'glyph',
    },
  );
};

export const useListItemStyles = ({
  against,
  attributes,
  layout,
}: {
  against?: Against;
  attributes?: ShortcodeAttributesProps;
  layout?: Layout;
}) => {
  const { theme } = useTheme();

  const alignment = findResponsiveItem(useBreakpoints(), [
    layout?.alignmentMobile ?? Alignment.STARTING,
    layout?.alignmentTablet ?? Alignment.STARTING,
    layout?.alignment ?? Alignment.STARTING,
  ]);

  return useStyles(
    {
      default: {
        root: {
          paddingLeft: 0,
          marginBottom: cssTheme.gu1,
        },
        icon: {
          width: cssTheme.gu2,
          minWidth: cssTheme.gu2,
          color: getTitleColor(theme, against),
        },
        text: {
          paddingLeft: 0,
          color: getBodyColor(theme, against),
        },
      },
      glyph: {
        root: {
          display: 'flex',
        },
        wrapper: {
          display: 'flex',
        },
        text: {
          paddingLeft: cssTheme.gu2,
        },
      },
      number: {
        text: {
          paddingLeft: cssTheme.gu1,
        },
      },
      [modifier('alignment', Alignment.CENTER)]: {
        root: {
          justifyContent: 'center',
        },
      },
    },
    {
      against,
      alignment,
      glyph: (attributes?.style || null) === 'glyph',
      number: (attributes?.style || null) === 'number',
    },
  );
};
